export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/25179188160551811f96efa94d747526.jpg"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/30 to-white/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <p className="text-xs font-medium text-gray-600 tracking-widest uppercase mb-6">
            Premium Cosmetics OEM/ODM Partner
          </p>
          
          <h1 className="font-serif text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
            브랜드의 가치를<br />
            완성하는<br />
            원스톱 뷰티 솔루션
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-700 mb-12 font-light">
            기획부터 생산까지, 글로리브가 함께합니다
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="px-8 py-4 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap"
            >
              서비스 알아보기
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="px-8 py-4 bg-transparent border-2 border-gray-900 text-gray-900 text-sm font-medium rounded-full hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              포트폴리오 보기
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 right-12 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <span className="text-xs text-gray-600 font-medium">SCROLL</span>
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-down-line text-gray-900 text-xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
